<template>
    <footer class="footer">
        <div>{{ siteName }} © 2025</div>
        <div>地址：海南省三亚市崖州区兴滨三横路椰岛阳光花园A区立宇办公楼三楼 | 电话：15308032337</div>
        <div>备案号：{{ icpInfo }}</div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            siteName: '海南鼎昂建筑工程有限公司',
            icpInfo: ''
        };
    },
    created() {
        // 读取 main.js 缓存的全局 SEO（简单读 window 变量以避免跨组件通讯改造）
        if (window.__GLOBAL_SEO__) {
            this.siteName = window.__GLOBAL_SEO__.siteName || this.siteName;
            this.icpInfo = window.__GLOBAL_SEO__.footerInfo || this.icpInfo;
        }
        // 监听 SEO 更新事件，确保接口异步返回后能更新页脚备案号
        this._onSeoUpdated = (e) => {
            const seo = (e && e.detail) || window.__GLOBAL_SEO__ || {};
            this.siteName = seo.siteName || this.siteName;
            this.icpInfo = seo.footerInfo || this.icpInfo;
        };
        window.addEventListener('seo-updated', this._onSeoUpdated);
    },
    beforeDestroy() {
        window.removeEventListener('seo-updated', this._onSeoUpdated);
    }
};
</script>

<style scoped>
.footer {
    background: #1a2a47;
    color: #fff;
    text-align: center;
    padding: 24px 0 12px 0;
    font-size: 14px;
    margin-top: 48px;
}
</style>